/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StoreImport } from './routes/store'
import { Route as MatsImport } from './routes/mats'
import { Route as LeaderboardImport } from './routes/leaderboard'
import { Route as HomeImport } from './routes/home'
import { Route as DepositImport } from './routes/deposit'
import { Route as MatsnetStoreImport } from './routes/matsnet/store'
import { Route as MatsnetBorrowImport } from './routes/matsnet/borrow'
import { Route as HodlWithPartnerSlugImport } from './routes/hodl-with.$partnerSlug'

// Create Virtual Routes

const VaultcampLazyImport = createFileRoute('/vaultcamp')()
const VaultLazyImport = createFileRoute('/vault')()
const TermsLazyImport = createFileRoute('/terms')()
const SwapLazyImport = createFileRoute('/swap')()
const RewardsLazyImport = createFileRoute('/rewards')()
const PrivacyLazyImport = createFileRoute('/privacy')()
const HodlEthereumLazyImport = createFileRoute('/hodl-ethereum')()
const HodlLazyImport = createFileRoute('/hodl')()
const ExploreLazyImport = createFileRoute('/explore')()
const EarnLazyImport = createFileRoute('/earn')()
const BorrowLazyImport = createFileRoute('/borrow')()
const AuthLazyImport = createFileRoute('/auth')()
const AboutLazyImport = createFileRoute('/about')()
const IndexLazyImport = createFileRoute('/')()
const MatsnetEarnLazyImport = createFileRoute('/matsnet/earn')()
const FeatureMusdLazyImport = createFileRoute('/feature/musd')()
const FeatureGrowthLazyImport = createFileRoute('/feature/growth')()
const FeatureBorrowLazyImport = createFileRoute('/feature/borrow')()

// Create/Update Routes

const VaultcampLazyRoute = VaultcampLazyImport.update({
  id: '/vaultcamp',
  path: '/vaultcamp',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/vaultcamp.lazy').then((d) => d.Route))

const VaultLazyRoute = VaultLazyImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/vault.lazy').then((d) => d.Route))

const TermsLazyRoute = TermsLazyImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/terms.lazy').then((d) => d.Route))

const SwapLazyRoute = SwapLazyImport.update({
  id: '/swap',
  path: '/swap',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/swap.lazy').then((d) => d.Route))

const RewardsLazyRoute = RewardsLazyImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/rewards.lazy').then((d) => d.Route))

const PrivacyLazyRoute = PrivacyLazyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/privacy.lazy').then((d) => d.Route))

const HodlEthereumLazyRoute = HodlEthereumLazyImport.update({
  id: '/hodl-ethereum',
  path: '/hodl-ethereum',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/hodl-ethereum.lazy').then((d) => d.Route))

const HodlLazyRoute = HodlLazyImport.update({
  id: '/hodl',
  path: '/hodl',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/hodl.lazy').then((d) => d.Route))

const ExploreLazyRoute = ExploreLazyImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/explore.lazy').then((d) => d.Route))

const EarnLazyRoute = EarnLazyImport.update({
  id: '/earn',
  path: '/earn',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/earn.lazy').then((d) => d.Route))

const BorrowLazyRoute = BorrowLazyImport.update({
  id: '/borrow',
  path: '/borrow',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/borrow.lazy').then((d) => d.Route))

const AuthLazyRoute = AuthLazyImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/auth.lazy').then((d) => d.Route))

const AboutLazyRoute = AboutLazyImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const StoreRoute = StoreImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => rootRoute,
} as any)

const MatsRoute = MatsImport.update({
  id: '/mats',
  path: '/mats',
  getParentRoute: () => rootRoute,
} as any)

const LeaderboardRoute = LeaderboardImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRoute,
} as any)

const HomeRoute = HomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/home.lazy').then((d) => d.Route))

const DepositRoute = DepositImport.update({
  id: '/deposit',
  path: '/deposit',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const MatsnetEarnLazyRoute = MatsnetEarnLazyImport.update({
  id: '/matsnet/earn',
  path: '/matsnet/earn',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/matsnet/earn.lazy').then((d) => d.Route))

const FeatureMusdLazyRoute = FeatureMusdLazyImport.update({
  id: '/feature/musd',
  path: '/feature/musd',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/feature/musd.lazy').then((d) => d.Route))

const FeatureGrowthLazyRoute = FeatureGrowthLazyImport.update({
  id: '/feature/growth',
  path: '/feature/growth',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/feature/growth.lazy').then((d) => d.Route),
)

const FeatureBorrowLazyRoute = FeatureBorrowLazyImport.update({
  id: '/feature/borrow',
  path: '/feature/borrow',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/feature/borrow.lazy').then((d) => d.Route),
)

const MatsnetStoreRoute = MatsnetStoreImport.update({
  id: '/matsnet/store',
  path: '/matsnet/store',
  getParentRoute: () => rootRoute,
} as any)

const MatsnetBorrowRoute = MatsnetBorrowImport.update({
  id: '/matsnet/borrow',
  path: '/matsnet/borrow',
  getParentRoute: () => rootRoute,
} as any)

const HodlWithPartnerSlugRoute = HodlWithPartnerSlugImport.update({
  id: '/hodl-with/$partnerSlug',
  path: '/hodl-with/$partnerSlug',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/deposit': {
      id: '/deposit'
      path: '/deposit'
      fullPath: '/deposit'
      preLoaderRoute: typeof DepositImport
      parentRoute: typeof rootRoute
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeImport
      parentRoute: typeof rootRoute
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardImport
      parentRoute: typeof rootRoute
    }
    '/mats': {
      id: '/mats'
      path: '/mats'
      fullPath: '/mats'
      preLoaderRoute: typeof MatsImport
      parentRoute: typeof rootRoute
    }
    '/store': {
      id: '/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof StoreImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthLazyImport
      parentRoute: typeof rootRoute
    }
    '/borrow': {
      id: '/borrow'
      path: '/borrow'
      fullPath: '/borrow'
      preLoaderRoute: typeof BorrowLazyImport
      parentRoute: typeof rootRoute
    }
    '/earn': {
      id: '/earn'
      path: '/earn'
      fullPath: '/earn'
      preLoaderRoute: typeof EarnLazyImport
      parentRoute: typeof rootRoute
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreLazyImport
      parentRoute: typeof rootRoute
    }
    '/hodl': {
      id: '/hodl'
      path: '/hodl'
      fullPath: '/hodl'
      preLoaderRoute: typeof HodlLazyImport
      parentRoute: typeof rootRoute
    }
    '/hodl-ethereum': {
      id: '/hodl-ethereum'
      path: '/hodl-ethereum'
      fullPath: '/hodl-ethereum'
      preLoaderRoute: typeof HodlEthereumLazyImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyLazyImport
      parentRoute: typeof rootRoute
    }
    '/rewards': {
      id: '/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof RewardsLazyImport
      parentRoute: typeof rootRoute
    }
    '/swap': {
      id: '/swap'
      path: '/swap'
      fullPath: '/swap'
      preLoaderRoute: typeof SwapLazyImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsLazyImport
      parentRoute: typeof rootRoute
    }
    '/vault': {
      id: '/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof VaultLazyImport
      parentRoute: typeof rootRoute
    }
    '/vaultcamp': {
      id: '/vaultcamp'
      path: '/vaultcamp'
      fullPath: '/vaultcamp'
      preLoaderRoute: typeof VaultcampLazyImport
      parentRoute: typeof rootRoute
    }
    '/hodl-with/$partnerSlug': {
      id: '/hodl-with/$partnerSlug'
      path: '/hodl-with/$partnerSlug'
      fullPath: '/hodl-with/$partnerSlug'
      preLoaderRoute: typeof HodlWithPartnerSlugImport
      parentRoute: typeof rootRoute
    }
    '/matsnet/borrow': {
      id: '/matsnet/borrow'
      path: '/matsnet/borrow'
      fullPath: '/matsnet/borrow'
      preLoaderRoute: typeof MatsnetBorrowImport
      parentRoute: typeof rootRoute
    }
    '/matsnet/store': {
      id: '/matsnet/store'
      path: '/matsnet/store'
      fullPath: '/matsnet/store'
      preLoaderRoute: typeof MatsnetStoreImport
      parentRoute: typeof rootRoute
    }
    '/feature/borrow': {
      id: '/feature/borrow'
      path: '/feature/borrow'
      fullPath: '/feature/borrow'
      preLoaderRoute: typeof FeatureBorrowLazyImport
      parentRoute: typeof rootRoute
    }
    '/feature/growth': {
      id: '/feature/growth'
      path: '/feature/growth'
      fullPath: '/feature/growth'
      preLoaderRoute: typeof FeatureGrowthLazyImport
      parentRoute: typeof rootRoute
    }
    '/feature/musd': {
      id: '/feature/musd'
      path: '/feature/musd'
      fullPath: '/feature/musd'
      preLoaderRoute: typeof FeatureMusdLazyImport
      parentRoute: typeof rootRoute
    }
    '/matsnet/earn': {
      id: '/matsnet/earn'
      path: '/matsnet/earn'
      fullPath: '/matsnet/earn'
      preLoaderRoute: typeof MatsnetEarnLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/deposit': typeof DepositRoute
  '/home': typeof HomeRoute
  '/leaderboard': typeof LeaderboardRoute
  '/mats': typeof MatsRoute
  '/store': typeof StoreRoute
  '/about': typeof AboutLazyRoute
  '/auth': typeof AuthLazyRoute
  '/borrow': typeof BorrowLazyRoute
  '/earn': typeof EarnLazyRoute
  '/explore': typeof ExploreLazyRoute
  '/hodl': typeof HodlLazyRoute
  '/hodl-ethereum': typeof HodlEthereumLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/swap': typeof SwapLazyRoute
  '/terms': typeof TermsLazyRoute
  '/vault': typeof VaultLazyRoute
  '/vaultcamp': typeof VaultcampLazyRoute
  '/hodl-with/$partnerSlug': typeof HodlWithPartnerSlugRoute
  '/matsnet/borrow': typeof MatsnetBorrowRoute
  '/matsnet/store': typeof MatsnetStoreRoute
  '/feature/borrow': typeof FeatureBorrowLazyRoute
  '/feature/growth': typeof FeatureGrowthLazyRoute
  '/feature/musd': typeof FeatureMusdLazyRoute
  '/matsnet/earn': typeof MatsnetEarnLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/deposit': typeof DepositRoute
  '/home': typeof HomeRoute
  '/leaderboard': typeof LeaderboardRoute
  '/mats': typeof MatsRoute
  '/store': typeof StoreRoute
  '/about': typeof AboutLazyRoute
  '/auth': typeof AuthLazyRoute
  '/borrow': typeof BorrowLazyRoute
  '/earn': typeof EarnLazyRoute
  '/explore': typeof ExploreLazyRoute
  '/hodl': typeof HodlLazyRoute
  '/hodl-ethereum': typeof HodlEthereumLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/swap': typeof SwapLazyRoute
  '/terms': typeof TermsLazyRoute
  '/vault': typeof VaultLazyRoute
  '/vaultcamp': typeof VaultcampLazyRoute
  '/hodl-with/$partnerSlug': typeof HodlWithPartnerSlugRoute
  '/matsnet/borrow': typeof MatsnetBorrowRoute
  '/matsnet/store': typeof MatsnetStoreRoute
  '/feature/borrow': typeof FeatureBorrowLazyRoute
  '/feature/growth': typeof FeatureGrowthLazyRoute
  '/feature/musd': typeof FeatureMusdLazyRoute
  '/matsnet/earn': typeof MatsnetEarnLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/deposit': typeof DepositRoute
  '/home': typeof HomeRoute
  '/leaderboard': typeof LeaderboardRoute
  '/mats': typeof MatsRoute
  '/store': typeof StoreRoute
  '/about': typeof AboutLazyRoute
  '/auth': typeof AuthLazyRoute
  '/borrow': typeof BorrowLazyRoute
  '/earn': typeof EarnLazyRoute
  '/explore': typeof ExploreLazyRoute
  '/hodl': typeof HodlLazyRoute
  '/hodl-ethereum': typeof HodlEthereumLazyRoute
  '/privacy': typeof PrivacyLazyRoute
  '/rewards': typeof RewardsLazyRoute
  '/swap': typeof SwapLazyRoute
  '/terms': typeof TermsLazyRoute
  '/vault': typeof VaultLazyRoute
  '/vaultcamp': typeof VaultcampLazyRoute
  '/hodl-with/$partnerSlug': typeof HodlWithPartnerSlugRoute
  '/matsnet/borrow': typeof MatsnetBorrowRoute
  '/matsnet/store': typeof MatsnetStoreRoute
  '/feature/borrow': typeof FeatureBorrowLazyRoute
  '/feature/growth': typeof FeatureGrowthLazyRoute
  '/feature/musd': typeof FeatureMusdLazyRoute
  '/matsnet/earn': typeof MatsnetEarnLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/deposit'
    | '/home'
    | '/leaderboard'
    | '/mats'
    | '/store'
    | '/about'
    | '/auth'
    | '/borrow'
    | '/earn'
    | '/explore'
    | '/hodl'
    | '/hodl-ethereum'
    | '/privacy'
    | '/rewards'
    | '/swap'
    | '/terms'
    | '/vault'
    | '/vaultcamp'
    | '/hodl-with/$partnerSlug'
    | '/matsnet/borrow'
    | '/matsnet/store'
    | '/feature/borrow'
    | '/feature/growth'
    | '/feature/musd'
    | '/matsnet/earn'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/deposit'
    | '/home'
    | '/leaderboard'
    | '/mats'
    | '/store'
    | '/about'
    | '/auth'
    | '/borrow'
    | '/earn'
    | '/explore'
    | '/hodl'
    | '/hodl-ethereum'
    | '/privacy'
    | '/rewards'
    | '/swap'
    | '/terms'
    | '/vault'
    | '/vaultcamp'
    | '/hodl-with/$partnerSlug'
    | '/matsnet/borrow'
    | '/matsnet/store'
    | '/feature/borrow'
    | '/feature/growth'
    | '/feature/musd'
    | '/matsnet/earn'
  id:
    | '__root__'
    | '/'
    | '/deposit'
    | '/home'
    | '/leaderboard'
    | '/mats'
    | '/store'
    | '/about'
    | '/auth'
    | '/borrow'
    | '/earn'
    | '/explore'
    | '/hodl'
    | '/hodl-ethereum'
    | '/privacy'
    | '/rewards'
    | '/swap'
    | '/terms'
    | '/vault'
    | '/vaultcamp'
    | '/hodl-with/$partnerSlug'
    | '/matsnet/borrow'
    | '/matsnet/store'
    | '/feature/borrow'
    | '/feature/growth'
    | '/feature/musd'
    | '/matsnet/earn'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  DepositRoute: typeof DepositRoute
  HomeRoute: typeof HomeRoute
  LeaderboardRoute: typeof LeaderboardRoute
  MatsRoute: typeof MatsRoute
  StoreRoute: typeof StoreRoute
  AboutLazyRoute: typeof AboutLazyRoute
  AuthLazyRoute: typeof AuthLazyRoute
  BorrowLazyRoute: typeof BorrowLazyRoute
  EarnLazyRoute: typeof EarnLazyRoute
  ExploreLazyRoute: typeof ExploreLazyRoute
  HodlLazyRoute: typeof HodlLazyRoute
  HodlEthereumLazyRoute: typeof HodlEthereumLazyRoute
  PrivacyLazyRoute: typeof PrivacyLazyRoute
  RewardsLazyRoute: typeof RewardsLazyRoute
  SwapLazyRoute: typeof SwapLazyRoute
  TermsLazyRoute: typeof TermsLazyRoute
  VaultLazyRoute: typeof VaultLazyRoute
  VaultcampLazyRoute: typeof VaultcampLazyRoute
  HodlWithPartnerSlugRoute: typeof HodlWithPartnerSlugRoute
  MatsnetBorrowRoute: typeof MatsnetBorrowRoute
  MatsnetStoreRoute: typeof MatsnetStoreRoute
  FeatureBorrowLazyRoute: typeof FeatureBorrowLazyRoute
  FeatureGrowthLazyRoute: typeof FeatureGrowthLazyRoute
  FeatureMusdLazyRoute: typeof FeatureMusdLazyRoute
  MatsnetEarnLazyRoute: typeof MatsnetEarnLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  DepositRoute: DepositRoute,
  HomeRoute: HomeRoute,
  LeaderboardRoute: LeaderboardRoute,
  MatsRoute: MatsRoute,
  StoreRoute: StoreRoute,
  AboutLazyRoute: AboutLazyRoute,
  AuthLazyRoute: AuthLazyRoute,
  BorrowLazyRoute: BorrowLazyRoute,
  EarnLazyRoute: EarnLazyRoute,
  ExploreLazyRoute: ExploreLazyRoute,
  HodlLazyRoute: HodlLazyRoute,
  HodlEthereumLazyRoute: HodlEthereumLazyRoute,
  PrivacyLazyRoute: PrivacyLazyRoute,
  RewardsLazyRoute: RewardsLazyRoute,
  SwapLazyRoute: SwapLazyRoute,
  TermsLazyRoute: TermsLazyRoute,
  VaultLazyRoute: VaultLazyRoute,
  VaultcampLazyRoute: VaultcampLazyRoute,
  HodlWithPartnerSlugRoute: HodlWithPartnerSlugRoute,
  MatsnetBorrowRoute: MatsnetBorrowRoute,
  MatsnetStoreRoute: MatsnetStoreRoute,
  FeatureBorrowLazyRoute: FeatureBorrowLazyRoute,
  FeatureGrowthLazyRoute: FeatureGrowthLazyRoute,
  FeatureMusdLazyRoute: FeatureMusdLazyRoute,
  MatsnetEarnLazyRoute: MatsnetEarnLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/deposit",
        "/home",
        "/leaderboard",
        "/mats",
        "/store",
        "/about",
        "/auth",
        "/borrow",
        "/earn",
        "/explore",
        "/hodl",
        "/hodl-ethereum",
        "/privacy",
        "/rewards",
        "/swap",
        "/terms",
        "/vault",
        "/vaultcamp",
        "/hodl-with/$partnerSlug",
        "/matsnet/borrow",
        "/matsnet/store",
        "/feature/borrow",
        "/feature/growth",
        "/feature/musd",
        "/matsnet/earn"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/deposit": {
      "filePath": "deposit.tsx"
    },
    "/home": {
      "filePath": "home.tsx"
    },
    "/leaderboard": {
      "filePath": "leaderboard.tsx"
    },
    "/mats": {
      "filePath": "mats.tsx"
    },
    "/store": {
      "filePath": "store.tsx"
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/auth": {
      "filePath": "auth.lazy.tsx"
    },
    "/borrow": {
      "filePath": "borrow.lazy.tsx"
    },
    "/earn": {
      "filePath": "earn.lazy.tsx"
    },
    "/explore": {
      "filePath": "explore.lazy.tsx"
    },
    "/hodl": {
      "filePath": "hodl.lazy.tsx"
    },
    "/hodl-ethereum": {
      "filePath": "hodl-ethereum.lazy.tsx"
    },
    "/privacy": {
      "filePath": "privacy.lazy.tsx"
    },
    "/rewards": {
      "filePath": "rewards.lazy.tsx"
    },
    "/swap": {
      "filePath": "swap.lazy.tsx"
    },
    "/terms": {
      "filePath": "terms.lazy.tsx"
    },
    "/vault": {
      "filePath": "vault.lazy.tsx"
    },
    "/vaultcamp": {
      "filePath": "vaultcamp.lazy.tsx"
    },
    "/hodl-with/$partnerSlug": {
      "filePath": "hodl-with.$partnerSlug.tsx"
    },
    "/matsnet/borrow": {
      "filePath": "matsnet/borrow.tsx"
    },
    "/matsnet/store": {
      "filePath": "matsnet/store.tsx"
    },
    "/feature/borrow": {
      "filePath": "feature/borrow.lazy.tsx"
    },
    "/feature/growth": {
      "filePath": "feature/growth.lazy.tsx"
    },
    "/feature/musd": {
      "filePath": "feature/musd.lazy.tsx"
    },
    "/matsnet/earn": {
      "filePath": "matsnet/earn.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
